import Skeleton from 'react-loading-skeleton'
import styles from '../styles.module.scss'

const MOCK_NUMBER_OF_STORES = new Array(10).fill(null).map((e, i) => i)

const StoreItem = () => {
  return (
    <section className={styles['stores__accordion-container']}>
      <div>
        <Skeleton height={200} className={styles.stores__image} />
        <div className={styles.stores__caption}>
          <Skeleton className={styles.stores__name} count={2} />
        </div>
      </div>
    </section>
  )
}

const DesktopSkeleton = () => {
  return (
    <div className={styles.stores}>
      <Skeleton className={styles.stores__header} />
      <Skeleton className={styles.stores__subheader} />
      <div className={styles['stores__store-container']}>
        {MOCK_NUMBER_OF_STORES.map(item => (
          <StoreItem key={item} />
        ))}
      </div>
    </div>
  )
}

export default DesktopSkeleton
